import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Stack, Text, Visible } from '@leroy-merlin-br/backyard-react-ui'

import { formatDate } from 'reactUtils/date'

import { Avatar } from 'lmcv/components/Avatar'

import * as S from './styled'

const Status = ({ status, expireAt }) => {
  const MAP_STATUS_TEXT = {
    Pendente: '',
    Expirado: 'Expirado',
    Ativo: 'Finaliza',
    Concluído: 'Finalizado',
    Finalizado: 'Finalizado'
  }

  if (expireAt && MAP_STATUS_TEXT[status]) {
    return (
      <S.ItemCol>
        <S.TextDate size="mega" noMargin>
          <strong>{MAP_STATUS_TEXT[status]} em:</strong>{' '}
          {formatDate(expireAt, 'DD/MM/YYYY')}
        </S.TextDate>
      </S.ItemCol>
    )
  }

  return null
}

const MessageInvites = ({ invites }) => {
  if (invites && invites > 1) {
    return `Você possui ${invites} convites para enviar para seus clientes`
  }

  if (invites && invites === 1) {
    return `Você possui ${invites} convite para enviar para seus clientes`
  }

  return 'Você atingiu o número máximo de convites para enviar'
}

const List = ({ data, remainingInvites, onClickAdd }) => (
  <Fragment>
    {data.length
      ? (
      <S.List>
        {data.map(({ id, customerName, status, projectName, expireAt }) => (
          <S.Item key={id} as={Link} to={`/cliente/${id}`}>
            <S.ItemCol>
              <Avatar name={customerName} />

              <S.Info>
                <Stack spacing="bit">
                  <S.Name size="kilo" noMargin>
                    {customerName}
                  </S.Name>
                  <Visible untilKilo kilo>
                    <S.ProjectNameMobile size="mega" noMargin>
                      {projectName}
                    </S.ProjectNameMobile>
                  </Visible>
                  <S.Status color={status.toLowerCase()}>
                    <Text size="kilo" noMargin>
                      {status}
                    </Text>
                  </S.Status>
                </Stack>
              </S.Info>
            </S.ItemCol>
            <S.ItemCol>
              <div>
                <S.TextProject size="mega" noMargin>
                  Nome do Projeto:
                </S.TextProject>
                <S.TextProjectName noMargin>{projectName}</S.TextProjectName>
              </div>
            </S.ItemCol>
            <Status expireAt={expireAt} status={status} />
          </S.Item>
        ))}
      </S.List>
        )
      : (
      <Stack spacing="byte">
        <S.Title size="tera" noMargin>Você ainda não possui nenhum cliente</S.Title>
        <S.Description size="kilo" noMargin>
          Clique em adicionar clientes para começar a utilizar a plataforma
        </S.Description>
      </Stack>
        )}

    <S.Divider />

    <S.Footer>
      <S.TextFooter>
        <MessageInvites invites={remainingInvites} />
      </S.TextFooter>

      <Button size="kilo" isDisabled={!remainingInvites} onClick={onClickAdd}>
        Adicionar {data.length > 0 ? 'mais clientes' : 'cliente'}
      </Button>
    </S.Footer>
  </Fragment>
)

List.defaultProps = {
  data: PropTypes.array.isRequired,
  onClickAdd: PropTypes.func
}

export default List
